import { oc } from '@orpc/contract';
import { setTemplateReferencePriceInputSchema, setTemplateReferencePriceOutputSchema } from '../schemas/templates.schemas.js';
/**
 * Writes the estimator's new last price into the template's draft, opening one from the published
 * version when none exists. Open to every member, like editing a draft; publishing stays ADMIN.
 */
export const setTemplateReferencePriceContract = oc
    .route({
    method: 'POST',
    path: '/templates/{templateId}/reference-price',
    tags: ['Templates'],
    summary: 'Put a new last price into the template draft',
})
    .input(setTemplateReferencePriceInputSchema)
    .output(setTemplateReferencePriceOutputSchema);
//# sourceMappingURL=set-template-reference-price.contract.js.map